import React from 'react';

import SkeletonItem from '../../SkeletonItem';

import './styles.scss';

const BannerSkeleton = () => (
  <header className={'banner skeleton-item skeleton-item--blue'} style={{ width: '100%', height: '380px' }}>
    <div className="container container--padding">
      <div className="banner__inner">
        <SkeletonItem className={'title banner__title'} style={{ width: '70%' }} />
      </div>
    </div>
  </header>
);

export default BannerSkeleton;
